var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2.66602H2.66683C1.93045 2.66602 1.3335 3.26297 1.3335 3.99935V11.9993C1.3335 12.7357 1.93045 13.3327 2.66683 13.3327H13.3335C14.0699 13.3327 14.6668 12.7357 14.6668 11.9993V3.99935C14.6668 3.26297 14.0699 2.66602 13.3335 2.66602Z",
    stroke: "#297166",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 4.66602L8.68683 8.46602C8.48101 8.59497 8.24304 8.66336 8.00016 8.66336C7.75729 8.66336 7.51932 8.59497 7.3135 8.46602L1.3335 4.66602",
    stroke: "#297166",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.19789d705fe5349e899a4c7a70722732.svg";
export { ForwardRef as ReactComponent };